import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {AddressQualityEnum} from "../../types/address-quality.enum";

export class AddressQualityMultiSelectListComponent implements IController {
  addressQualities: AddressQualityEnum[];
  options: string[];
  ngPlaceholder: any;
  onChange: Function;

  private selectedKeys: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    if (!this.options || !this.options.length) {
      this.options = angular.copy(Object.values(AddressQualityEnum));
    }
  }

  $onChanges(changes) {
    if (changes.addressQualities) {
      this.selectedKeys = [];
      _.forEach(this.addressQualities, (type) => {
        this.selectedKeys[type] = true;
      })
    }
  }

  onToggle(option, isSelected) {
    this.onChange({
      addressQualities: isSelected ? _.concat(this.addressQualities, [option]) :
        _.filter(this.addressQualities, (status) => {
          return status !== option;
        })
    });
  }

  onReset() {
    this.onChange({addressQualities: []});
  }

}

angular
  .module('bringoz.admin.addresses')
  .component('addressQualityMultiSelectList', {
    bindings: {
      addressQualities: '<',
      options: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./address-quality-multi-select-list.html').default,
    controller: AddressQualityMultiSelectListComponent
  });


